module.exports = __webpack_public_path__ + "media/definite-555.0a2c73b5.mp3";